import React from "react";
import styles from "./FacilitiesItem.module.css";

const FacilitiesItem = ({title, active, click, icon: Icon}) => {
  return (
    <a className={styles.FacilitiesItem + " " + (active ? styles.active : "")} onClick={click} href="#">
      <div className={styles.Image}>
        <Icon />
      </div>
      <h2 className={styles.Title}>{title}</h2>
    </a>
  );
};

export default FacilitiesItem;
